import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // service uuid
  serviceId: null,

  // model
  deliveryTypeMstModel: [],
  relationaFunctionModel: [],

  // データ更新の判別フラグ
  updated: false
}

const getters = {
	get: state => state
}

const actions = {
  show ({commit}, serviceId) {
		// cover
		this.dispatch('core/showModalCover')
		
    commit('showed', serviceId)
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},

  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {deliveryTypeMstParams, functionMstParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['const'],
        ['v1FunctionMstRelationalDeliveryTypeMstListGet'],
        [{}])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setRelationalFunctionModel', res[0].data.functions)
            console.log('relationaFunctionModel', state.relationaFunctionModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * データ更新判別フラグの切替
   */
  setUpdated ({commit}, flag) {
    commit('setUpdated', flag)
  }
}

const mutations = {
  showed (state, serviceId) {
    state.serviceId = serviceId
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // model
  setRelationalFunctionModel (state, data) {
    Vue.set(state, 'relationaFunctionModel', data)

    // 機能マスタに紐づく配信タイプマスタのリストをmodelに登録
    let list = []
    data.forEach(func => {
      func.deliveryTypes.forEach(deliveryType => {
        if (list.length) {
          if (list.filter(item => item.deliveryTypeMstUuid === deliveryType.deliveryTypeMstUuid).length === 0) {
            list.push(deliveryType)
          }
        } else {
          list.push(deliveryType)
        }
      });
    });
    Vue.set(state, 'deliveryTypeMstModel', list)
  },
  
  // form
  setUpdated (state, flag) {
    state.updated = flag
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
